<template>
  <div>
    <v-card width="100%" shaped :loading="loading">
      <v-card-title v-if="this.messagepreview">Forhåndsvisning</v-card-title>
      <transition name="slide-in-blurred-top">
        <div v-if="this.messagepreview" class="chat px-5 pb-2 mt-n8" style="white-space: pre-line;">
          <div class="ml-2 mt-5 skriver mb-n8 grey--text text--darken-2">
            <span v-if="this.afsender == user.number">+45</span>
            {{ this.afsender }}:
          </div>
          <div class="yours messages mb-3">
            <div class="message last" style="overflow:hidden">{{ this.messagepreview }}</div>
          </div>
        </div>
      </transition>
    </v-card>
  </div>
</template>

<script>
export default {
  props: [
    "warning",
    "message",
    "selected",
    "afsender",
    "loading",
    "tags",
    "user"
  ],
  computed: {
    messagepreview() {
      var previewtext = "";

      if (this.message) {
        localStorage.message = this.message;
        previewtext = this.message;

        if (this.afsender != this.user.number) {
          previewtext = previewtext + this.warning;
        }

        if (this.selected[0]) {
          for (let tag of this.tags) {
            previewtext = previewtext.replace(
              new RegExp(tag.tag, "g"),
              this.selected[0][tag.sub]
            );
          }
        }
      }

      return previewtext;
    }
  }
};
</script>

<style lang="scss" scoped>
.slide-in-blurred-top-enter-active {
  animation: slide-in-blurred-top 0.4s cubic-bezier(0.23, 1, 0.32, 1) both;
}
.slide-in-blurred-top-leave-active {
  animation: slide-in-blurred-top 0.5s cubic-bezier(0.23, 1, 0.32, 1) both
    reverse;
}

@keyframes slide-in-blurred-top {
  0% {
    transform: translateY(-50px) scaleY(2.5) scaleX(0.2);
    transform-origin: 50% 0%;
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scaleY(1) scaleX(1);
    transform-origin: 50% 50%;
    filter: blur(0);
    opacity: 1;
  }
}

.messages {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
}

.message {
  border-radius: 20px;
  padding: 8px 15px;
  margin-top: 5px;
  margin-bottom: 5px;
  display: inline-block;
  overflow: break-word;
}

.yours {
  align-items: flex-start;
}

.yours .message {
  margin-right: 15%;
  background-color: lightgrey;
  position: relative;
}

.yours .message.last:before {
  content: "";
  position: absolute;
  z-index: 0;
  bottom: 0;
  left: -17px;
  height: 20px;
  width: 20px;
  background: lightgrey;
  border-bottom-right-radius: 15px;
}
.yours .message.last:after {
  content: "";
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: -10px;
  width: 10px;
  height: 20px;
  background: lightgrey;
  border-bottom-right-radius: 10px;
}

.mine {
  align-items: flex-end;
}

.mine .message {
  color: white;
  margin-left: 25%;
  background: linear-gradient(to bottom, #00d0ea 0%, #0085d1 100%);
  background-attachment: fixed;
  position: relative;
}

.mine .message.last:before {
  content: "";
  position: absolute;
  z-index: 0;
  bottom: 0;
  right: -8px;
  height: 20px;
  width: 20px;
  background: linear-gradient(to bottom, #00d0ea 0%, #0085d1 100%);
  background-attachment: fixed;
  border-bottom-left-radius: 15px;
}

.mine .message.last:after {
  content: "";
  position: absolute;
  z-index: 1;
  bottom: 0;
  sright: -10px;
  width: 10px;
  height: 20px;
  background: white;
  border-bottom-left-radius: 10px;
}
</style>
